import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApiResponse, WorkflowResponse, WorkflowStageResponse,
  CreateWorkflowRequest, CreateWorkflowStageRequest, AssignStageUserRequest
} from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAllWorkflows(): Observable<ApiResponse<WorkflowResponse[]>> {
    return this.http.get<ApiResponse<WorkflowResponse[]>>(`${this.apiUrl}/workflows`);
  }

  getWorkflowByUid(uid: string): Observable<ApiResponse<WorkflowResponse>> {
    return this.http.get<ApiResponse<WorkflowResponse>>(`${this.apiUrl}/workflows/${uid}`);
  }

  createWorkflow(request: CreateWorkflowRequest): Observable<ApiResponse<WorkflowResponse>> {
    return this.http.post<ApiResponse<WorkflowResponse>>(`${this.apiUrl}/workflows/create`, request);
  }

  createWorkflowStage(request: CreateWorkflowStageRequest): Observable<ApiResponse<WorkflowStageResponse>> {
    return this.http.post<ApiResponse<WorkflowStageResponse>>(`${this.apiUrl}/workflow-stages/create`, request);
  }

  assignUserToStage(request: AssignStageUserRequest): Observable<ApiResponse<WorkflowStageResponse>> {
    return this.http.post<ApiResponse<WorkflowStageResponse>>(`${this.apiUrl}/workflow-stages/assign-user`, request);
  }
}
